import React, { FunctionComponent } from 'react';
import { useForm } from 'react-hook-form';

import { SubmitButton } from 'components';
import { getRecentInsurer } from 'scenes/motor/selectors';
import { getApiData } from 'scenes/common/helpers/apiData';
import { SelectQuestion } from 'scenes/common/components/Questions';
import { MotorFullPageProps } from 'scenes/motor/types';

const RECENT_INSURER = 'recentInsurer';

const RecentInsurerStep: FunctionComponent<MotorFullPageProps> = ({
  referenceData,
  funnelState,
  onNext,
}) => {
  const {
    recentInsurerOptions: {
      dontKnowOption,
      otherOption,
      notInsuredOption,
      mostCommonInsurerList,
      otherInsurerList,
    },
  } = getApiData(referenceData);
  const {
    formState: { isValid },
    handleSubmit,
    control,
  } = useForm({
    mode: 'onChange',
    reValidateMode: 'onChange',
    shouldUnregister: false,
    defaultValues: { [RECENT_INSURER]: getRecentInsurer(funnelState) },
  });

  const insuranceOptions = [
    { label: 'Most common', optionList: mostCommonInsurerList },
    { label: 'Other insurers', optionList: otherInsurerList },
    notInsuredOption,
    dontKnowOption,
    otherOption,
  ];

  return (
    <form onSubmit={handleSubmit(onNext)}>
      <SelectQuestion
        control={control}
        isLoading={false}
        stateKey={RECENT_INSURER}
        options={insuranceOptions}
        defaultValue={getRecentInsurer(funnelState)}
        question="Who is the main driver's current or most recent insurer?"
      />

      <SubmitButton enabled={isValid}>Next</SubmitButton>
    </form>
  );
};

export default RecentInsurerStep;
